import {
  Building2,
  Ambulance,
  Shield,
  Flame,
  Droplets,
  Pill,
  LayoutGrid,
} from "lucide-react";

export const SERVICE_CATEGORIES = [
  { key: "all", label: "All", icon: LayoutGrid, emoji: "📋" },
  { key: "hospital", label: "Hospital", icon: Building2, emoji: "🏥" },
  { key: "ambulance", label: "Ambulance", icon: Ambulance, emoji: "🚑" },
  { key: "police", label: "Police", icon: Shield, emoji: "🚓" },
  { key: "fire_brigade", label: "Fire", icon: Flame, emoji: "🔥" },
  { key: "blood_bank", label: "Blood Bank", icon: Droplets, emoji: "🩸" },
  { key: "pharmacy", label: "Pharmacy", icon: Pill, emoji: "💊" },
];

export const TYPE_LABELS = {
  hospital: "Hospital",
  ambulance: "Ambulance",
  police: "Police",
  fire_brigade: "Fire Brigade",
  blood_bank: "Blood Bank",
  pharmacy: "Pharmacy",
};

export function formatDistance(km) {
  if (km == null || Number.isNaN(km)) return null;
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km.toFixed(1)} km`;
}

export function getDirectionsUrl(service) {
  const coords = service?.location?.coordinates;
  if (coords?.length >= 2) {
    const [lng, lat] = coords;
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  }
  if (service?.address) {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(service.address)}`;
  }
  return null;
}

export function getMapPreviewUrl(services, coords) {
  if (coords?.lat != null && coords?.lng != null) {
    return `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;
  }
  const first = services?.find((s) => s.location?.coordinates?.length >= 2);
  if (first) {
    const [lng, lat] = first.location.coordinates;
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }
  return "https://www.google.com/maps";
}

export function getOpenStatus(service) {
  const hours = service?.metadata?.openHours;
  if (!hours) return null;

  const normalized = String(hours).toLowerCase();
  if (normalized.includes("24/7") || normalized.includes("24x7") || normalized.includes("24 hours")) {
    return { label: "Open 24 Hours", tone: "open", dot: "🟢" };
  }

  const closeMatch = hours.match(/-\s*(\d{1,2}(?::\d{2})?\s*(?:AM|PM|am|pm)?)/);
  if (closeMatch) {
    return { label: `Closes at ${closeMatch[1]}`, tone: "closing", dot: "🟠" };
  }

  return { label: hours, tone: "neutral", dot: "🟢" };
}

export function formatLastUpdated(date) {
  if (!date) return null;
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 45) return "Updated just now";
  if (seconds < 120) return "Updated a few seconds ago";
  if (seconds < 3600) return `Updated ${Math.floor(seconds / 60)} min ago`;
  return `Updated ${Math.floor(seconds / 3600)} hr ago`;
}
